module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mostSoldItems":"Most sold products","soldUnits":"Sold units","margin":"Unit Margin","KPILoadingError":"Error loading one or more KPIs"},"es":{"mostSoldItems":"Platos más vendidos","soldUnits":"Unidades","margin":"Margen Unitario","KPILoadingError":"Error cargando uno o más indicadores"}}')
  delete Component.options._Ctor
}
